/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PutModelPriceBodyRates = {
  inputTokens?: number | undefined;
  outputTokens?: number | undefined;
  cachedTokens?: number | undefined;
  reasoningTokens?: number | undefined;
  characters?: number | undefined;
  seconds?: number | undefined;
  image?: number | undefined;
  imageTiers?: { [k: string]: number } | undefined;
  searches?: number | undefined;
};

export type PutModelPriceBody = {
  model: string;
  rates: PutModelPriceBodyRates;
};

/** @internal */
export const PutModelPriceBodyRates$inboundSchema: z.ZodType<
  PutModelPriceBodyRates,
  z.ZodTypeDef,
  unknown
> = z.object({
  input_tokens: z.number().optional(),
  output_tokens: z.number().optional(),
  cached_tokens: z.number().optional(),
  reasoning_tokens: z.number().optional(),
  characters: z.number().optional(),
  seconds: z.number().optional(),
  image: z.number().optional(),
  image_tiers: z.record(z.number()).optional(),
  searches: z.number().optional(),
}).transform((v) => {
  return remap$(v, {
    "input_tokens": "inputTokens",
    "output_tokens": "outputTokens",
    "cached_tokens": "cachedTokens",
    "reasoning_tokens": "reasoningTokens",
    "image_tiers": "imageTiers",
  });
});
/** @internal */
export type PutModelPriceBodyRates$Outbound = {
  input_tokens?: number | undefined;
  output_tokens?: number | undefined;
  cached_tokens?: number | undefined;
  reasoning_tokens?: number | undefined;
  characters?: number | undefined;
  seconds?: number | undefined;
  image?: number | undefined;
  image_tiers?: { [k: string]: number } | undefined;
  searches?: number | undefined;
};

/** @internal */
export const PutModelPriceBodyRates$outboundSchema: z.ZodType<
  PutModelPriceBodyRates$Outbound,
  z.ZodTypeDef,
  PutModelPriceBodyRates
> = z.object({
  inputTokens: z.number().optional(),
  outputTokens: z.number().optional(),
  cachedTokens: z.number().optional(),
  reasoningTokens: z.number().optional(),
  characters: z.number().optional(),
  seconds: z.number().optional(),
  image: z.number().optional(),
  imageTiers: z.record(z.number()).optional(),
  searches: z.number().optional(),
}).transform((v) => {
  return remap$(v, {
    inputTokens: "input_tokens",
    outputTokens: "output_tokens",
    cachedTokens: "cached_tokens",
    reasoningTokens: "reasoning_tokens",
    imageTiers: "image_tiers",
  });
});

export function putModelPriceBodyRatesToJSON(
  putModelPriceBodyRates: PutModelPriceBodyRates,
): string {
  return JSON.stringify(
    PutModelPriceBodyRates$outboundSchema.parse(putModelPriceBodyRates),
  );
}
export function putModelPriceBodyRatesFromJSON(
  jsonString: string,
): SafeParseResult<PutModelPriceBodyRates, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PutModelPriceBodyRates$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PutModelPriceBodyRates' from JSON`,
  );
}

/** @internal */
export const PutModelPriceBody$inboundSchema: z.ZodType<
  PutModelPriceBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  model: z.string(),
  rates: z.lazy(() => PutModelPriceBodyRates$inboundSchema),
});
/** @internal */
export type PutModelPriceBody$Outbound = {
  model: string;
  rates: PutModelPriceBodyRates$Outbound;
};

/** @internal */
export const PutModelPriceBody$outboundSchema: z.ZodType<
  PutModelPriceBody$Outbound,
  z.ZodTypeDef,
  PutModelPriceBody
> = z.object({
  model: z.string(),
  rates: z.lazy(() => PutModelPriceBodyRates$outboundSchema),
});

export function putModelPriceBodyToJSON(
  putModelPriceBody: PutModelPriceBody,
): string {
  return JSON.stringify(
    PutModelPriceBody$outboundSchema.parse(putModelPriceBody),
  );
}
export function putModelPriceBodyFromJSON(
  jsonString: string,
): SafeParseResult<PutModelPriceBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PutModelPriceBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PutModelPriceBody' from JSON`,
  );
}
